import { createBrowserRouter, Navigate } from "react-router-dom";
import { App } from "@/App";
import { DealsPage } from "@/pages/DealsPage";
import { GateDemoPage } from "@/pages/GateDemoPage";
import { UploadValidatePage } from "@/pages/UploadValidatePage";
import { MasterDataPage } from "@/pages/MasterDataPage";
import { NewDealPage } from "@/pages/NewDealPage";
import { DealWorkspacePage } from "@/pages/DealWorkspacePage";
import { FlowPage } from "@/pages/FlowPage";
import { DistributorDeskLayout } from "@/pages/distributor/DistributorDeskLayout";
import { DistributorHome } from "@/pages/distributor/DistributorHome";
import { RelationshipsPage } from "@/pages/distributor/RelationshipsPage";
import { MaterialsPage } from "@/pages/distributor/MaterialsPage";
import { MarketingPage } from "@/pages/distributor/MarketingPage";
import { ContractChangesPage } from "@/pages/distributor/ContractChangesPage";
import { IssuesPage } from "@/pages/distributor/IssuesPage";
import { CountryDetailPage } from "@/pages/distributor/CountryDetailPage";

/**
 * App routes (B4 + v3 unified-trade-flow).
 *  - /            → /flow 리다이렉트 (통합 워크데스크가 기본 진입점)
 *  - /flow        통합 워크데스크 (시뮬레이션→계약→선적 딜→실적, 한 페이지)
 *  - /home        기존 홈
 *  - /deals       딜 목록 (Supabase, env-guarded)
 *  - /deals/new   새 딜 만들기 (entrance ②: 폼 입력 → 검증 + 생성. ?contract= 프리필)
 *  - /deals/:id   거래 워크스페이스 (gate + CI/PL 생성)
 *  - /master      마스터데이터 (거래처·제품·자사)
 *  - /upload      엑셀 업로드 검증 (entrance ①: DB-free)
 *  - /gate        발행 게이트 데모 (룰/머지 오프라인)
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Navigate to="/flow" replace /> },
      { path: "flow", element: <FlowPage /> },
      { path: "deals", element: <DealsPage /> },
      { path: "deals/new", element: <NewDealPage /> },
      { path: "deals/:id", element: <DealWorkspacePage /> },
      { path: "master", element: <MasterDataPage /> },
      { path: "upload", element: <UploadValidatePage /> },
      { path: "gate", element: <GateDemoPage /> },
      {
        path: "distributor",
        element: <DistributorDeskLayout />,
        children: [
          { index: true, element: <DistributorHome /> },
          { path: "relationships", element: <RelationshipsPage /> },
          { path: "materials", element: <MaterialsPage /> },
          { path: "marketing", element: <MarketingPage /> },
          { path: "contracts", element: <ContractChangesPage /> },
          { path: "issues", element: <IssuesPage /> },
          { path: ":countryId", element: <CountryDetailPage /> },
        ],
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
